import { useEffect, useState } from "react";
import { PrimaryButton, Stack, TextField } from "@fluentui/react";
import { useNavigate } from "react-router-dom";
import { TLogin, TLoginState } from "../constants/types";
import cookie from 'react-cookies';

export interface ILoginProps {
}

const Login : React.FunctionComponent<ILoginProps> = (props : ILoginProps) => {
    const [username, setusername] = useState<string>("");
    const [password, setpassword] = useState<string>("");
    const [dev, setdev] = useState<boolean>(false);
    const [apiUrl, setapiUrl] = useState<string>("");
    const [site, setsite] = useState<string>("");
    const [error, seterror] = useState<string>("");
    const navigate = useNavigate();

    useEffect(() => {
        let dev = false;
        let selectedSite = "";
        if (document.location.host === "localhost:3000") {
            dev = true;
            selectedSite = "retrocollectie";
        } else {
            selectedSite = document.location.host.split('.')[1];
        }

        setusername(selectedSite);

        let apiUrl =  document.location.origin + "/Backend";
        if (dev) {
            apiUrl = "http://127.0.0.1:36";
        }

        setapiUrl(apiUrl);
        setdev(dev);
        setsite(selectedSite);

        setapiUrl(apiUrl);
        setdev(dev);
    },[]);

    function login() {
        const login : TLogin = {
            username: username,
            site: site,
            password: password
        };
        fetch(`${apiUrl}/Login`, {
            method: "Post", 
            mode: "cors", 
            headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Accept-Encoding": "gzip, deflate ,br"
            },
            referrerPolicy: "origin-when-cross-origin", 
            body: JSON.stringify(login), 
        }).then((response) => response.json()).then((data: TLoginState) => {
            if (data.success) {
                setpassword("");
                setusername("");
                cookie.save('token', data.token, { path: '/', secure: true});
                cookie.save('username', username, { path: '/' });
                if (site === "collectietekoop") {
                    navigate('/superadmin');
                } else {
                    navigate('/admin');
                }
            } else {
                seterror(data.error);
            }
        });
    }

    return (
        <Stack horizontalAlign="center" style={{height:"100%"}}>
            <Stack horizontal horizontalAlign='center'>
                {site === "pokemoncollectie" ?
                    <img src='https://pokemoncollectie.nl/assets/pokemon%20kaarten.webp?v=3' style={{ cursor: "pointer", maxWidth: "80%" }} />
                    :
                    <img src={`https://${site}.nl/assets/sitebanner.png?v=1`} style={{ cursor: "pointer", maxWidth: "80%" }} />
                }
            </Stack>
            <Stack style={{maxWidth:400,marginTop:"10%"}}>
                <TextField label="Gebruikersnaam" value={username} onChange={(e,v) => {setusername(v.toLowerCase());}} />
                <TextField type="password" label="Wachtwoord" value={password} onChange={(e,v) => {setpassword(v);}} />
                <span style={{color:"red"}}>{error}</span>
                <br />
                <PrimaryButton text="Inloggen" onClick={login} />
            </Stack>
        </Stack>
    );
}

export default Login;